export default "__VITE_ASSET___6YYpJlo__"